import React, { useEffect } from "react";
import HomePageBanner from "../components/Home/HomePageBanner";
import HomePageDetails from "../components/Home/HomePageDetails";
import Brain3D from "../components/Home/Brain3D";
import Equipment from "../components/Home/Equipment";
import MarqueeText from '../components/Home/MarqueeText';
import GetINTouch from "../components/Contactus/GetINTouch";
const HomePage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    }); // Scroll to the top when the component mounts
  }, []);
  return (
    <>
      <HomePageBanner />
      <Equipment />
      <MarqueeText />
      <Brain3D />
      <HomePageDetails />
      <GetINTouch />
    </>
  );
};

export default HomePage;
